export default {
  init(vue) {
    return {
      queryById(id) {
        return vue.$http({
          method: 'GET',
          url: `/pages/channel/get`,
          params: {
            id: id
          }
        })
      },
      query(searchParams) {
        return vue.$http({
          method: 'GET',
          url: `/pages/channel/list`,
          params: searchParams
        })
      },
      save(data) {
        let _url = '/pages/channel/add'
        if (data.channelId) {
          _url = '/pages/channel/update'
        }
        return vue.$http({
          method: 'POST',
          url: _url,
          data: data
        })
      },
      getChannelList() {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/getChannelList`
        })
      },
      listDepositStatus() {
        return vue.$http({
          method: 'GET',
          url: `/pages/deposit/listDepositStatus`
        })
      },
      listCarrier() {
        return vue.$http({
          method: 'GET',
          url: `/pages/deposit/listCarrier`
        })
      },
      notifyChannel(oid) {
        return vue.$http({
          method: 'GET',
          url: `/pages/xxl/log/notifyChannel`,
          params: {
            id: oid
          }
        })
      },
      pushNotify(oid, typeParam) {
        return vue.$http({
          method: 'POST',
          url: `/pages/order/notifyChannel`,
          params: {
            orderId: oid,
            type: typeParam
          }
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/service/channel.service.js